<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="방지시설 사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="방지시설별 부품현황"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :merge="grid.merge"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="true"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'waste-report-manage',
  data() {
    return {
      grid: {
        merge: [
          { index: 1, colName: 'envAirMstOutletId' },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'envAirMstOutletName',
            field: 'envAirMstOutletName',
            label: '대기배출구(방지시설)',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'envAirMstOutletPartTypeName',
            field: 'envAirMstOutletPartTypeName',
            label: '부품타입',
            align: 'center',
            sortable: true,
          },
          {
            name: 'envAirMstOutletPartName',
            field: 'envAirMstOutletPartName',
            label: '부품명',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'maker',
            field: 'maker',
            label: '필터제조사',
            align: 'center',
            sortable: true,
          },
          {
            name: 'quality',
            field: 'quality',
            label: '필터재질',
            align: 'center',
            sortable: true,
          },
          {
            name: 'connType',
            field: 'connType',
            label: '체결타입',
            align: 'center',
            sortable: true,
          },
          {
            name: 'sizeName',
            field: 'sizeName',
            label: '사이즈',
            align: 'center',
            sortable: true,
          },
          {
            name: 'amount',
            field: 'amount',
            label: '수량',
            align: 'center',
            sortable: true,
          },
          {
            label: '청소',
            align: 'center',
            child: [
              // {
              //   name: 'cleanCycle',
              //   field: 'cleanCycle',
              //   label: '청소주기',
              //   align: 'center',
              //   sortable: true,
              // },
              {
                name: 'cleanDt',
                field: 'cleanDt',
                label: '청소완료일',
                align: 'center',
                sortable: true,
              },
              {
                name: 'cleanNextDt',
                field: 'cleanNextDt',
                label: '청소예정일',
                align: 'center',
                sortable: true,
              },
            ]
          },
          {
            label: '교체',
            align: 'center',
            child: [
              // {
              //   name: 'changeCycle',
              //   field: 'changeCycle',
              //   label: '교체주기',
              //   align: 'center',
              //   sortable: true,
              // },
              {
                name: 'changeDt',
                field: 'changeDt',
                label: '교체완료일',
                align: 'center',
                sortable: true,
              },
              {
                name: 'changeNextDt',
                field: 'changeNextDt',
                label: '교체예정일',
                align: 'center',
                sortable: true,
              },
            ]
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '50%',
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.air.mst.outlet.part.status;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row, col) {
      let tabname = '';
      if (col.name == 'envAirMstOutletName') {
        tabname = 'govScheduleInfo';
      } else if (col.name == 'envAirMstOutletPartName') {
        tabname = 'govScheduleHistory';
      }
      this.popupOptions.title = '대기 배출구(방지시설) 상세';
      this.popupOptions.param = {
        envAirMstOutletId: row.envAirMstOutletId,
        tabName: tabname,
      };
      this.popupOptions.target = () => import(`${"./airMaster01Detail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
